import {createSelector} from '@ngrx/store';
import {selectMediaEntities} from './media.reducer';

export const selectMediaSorted = createSelector(
	selectMediaEntities,
	mediaEntities => Object.values(mediaEntities).sort((m1, m2) => +new Date(m2.created) - +new Date(m1.created))
);

export const selectMediaById = (id: string) => createSelector(
	selectMediaEntities,
	mediaEntities => mediaEntities[id]
);
